import { createFileRoute } from "@tanstack/react-router";

import { Content } from "../../../../../../../features/dashboard/empresas/editar/$id/components/EditCompanyContent";

export const Route = createFileRoute("/_private/dashboard/_base/empresas/editar/$id/")({
  component: Content
});
